import { tns } from "tiny-slider/src/tiny-slider.module"

export default {

    props: {
        ratio: {
            type: String,
            default: '181:240',
            required: false
        }
    },

    data: (vm) => ({
        mobileRatio: vm.ratio,
        mobileWidth: vm.ratio.split(':')[0],
        oldWidth: document.documentElement.clientWidth,
        slider: null,
    }),

    mounted() {
        this.maybeSetSlider()

        let self = this;
        window.addEventListener('resize', () => { // only on width change because URL bar resizing on mobile
            let newWidth = document.documentElement.clientWidth;
            if (newWidth != self.oldWidth) {
                this.maybeSetSlider()
            }
            this.oldWidth = newWidth;
        });

        window.addEventListener('orientationchange', this.maybeSetSlider)
    },

    methods: {
        maybeSetSlider() {
            this.$nextTick(() => {
                this.$nextTick(() => {
                    if (this.$root.isMobile) {
                        this.calculateAspectRatio().then(() => {
                            this.slider = tns({
                                container: this.$refs.slider,
                                //preventScrollOnTouch: 'auto',
                                disable: false,
                                swipeAngle: false,
                                slideBy: 1,
                                gutter: 16,
                                autoplay: false,
                                controls: false,
                                touch: false,
                                nav: false,
                                mouseDrag: true,
                                loop: false,
                                fixedWidth: this.mobileWidth
                            });
                        });
                    }
                })
            })
        },
        calculateAspectRatio() {
            let divider = 2
            let w = this.ratio.split(':')[0];
            let h = this.ratio.split(':')[1];
            let ratio_coef = h / w;
            let offset = 16;
            if (window.innerWidth <= 1279.98) divider = 4;
            if (window.innerWidth <= 1023.98) divider = 3;
            if (window.innerWidth <= 767.98) divider = 2;
            if (ratio_coef < 1) divider--;
            let new_width = parseInt((this.$refs.sliderParent.offsetWidth - ((divider - 1) * offset) - 7) / divider);
            return new Promise((resolve, reject) => {
                this.mobileRatio = `${new_width}:${parseInt(new_width * (h / w))}`;
                this.mobileWidth = new_width;
                resolve()
            })
        },
    }
}